import { GIPIBaseAbstractModel } from "@gipi-shared/models/base-abstract.model";

export class ConfigurationSmartTef extends GIPIBaseAbstractModel {
    /** @Required URL Base da integração com a SmartTef */
    baseUrl: string;

    /** GW Token da integração. Caso `jwtStoreToken` seja nulo, o atributo não será nulo. */
    gwIntegrationToken: string;

    /** @Required GW Token da loja. */
    gwStoreToken: string;

    /** JWT Token da integração. Caso `jwtStoreToken` seja nulo, o atributo não será nulo. */
    jwtIntegrationToken: string;

    /** JWT Token da loja. Caso `gwIntegrationToken` ou `jwtIntegrationToken` seja nulo, o atributo não será nulo. */
    jwtStoreToken: string;
}
